module.exports = __webpack_public_path__ + "static/media/2@2x.7c8357ad.png";